import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAttendancesIndicatorC4Data } from "@/services/esus/indicator/esf/c4/getDetailedCitizensAttendancesIndicatorC4";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC4CitizenAttendancesHistoryItem } from "./IndicatorEsfC4CitizenAttendancesHistoryItem";
import { IndicatorEsfC4CitizenAttendancesHistoryInfo } from "./IndicatorEsfC4CitizenAttendancesHistoryInfo";
import { IndicatorEsfC4CitizenProcedureReqEvalsHistoryItem } from "./IndicatorEsfC4CitizenProcedureReqEvalsHistoryItem";

type IndicatorEsfC4CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC4Data;
};

export function IndicatorEsfC4CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC4CitizenAttendancesHistoryProps>) {
	const indicatorEsfC4CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAttendances.birthdate ? getAge(citizenWithAttendances.birthdate) : "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC4CitizenAttendancesHistoryInfo {...indicatorEsfC4CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEsfC4CitizenAttendancesHistoryItem
									attendance={attendance}
								/>
							),
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Aferições de PA"
				timeLineContents={(
					citizenWithAttendances.bloodPressureMeasurements ?? []
				).map<TimeLineContent>((bloodPressureMeasurement) => {
					return {
						content: (
							<IndicatorEsfC4CitizenAttendancesHistoryItem
								attendance={bloodPressureMeasurement}
							/>
						),
						eventDate: bloodPressureMeasurement.date
							? dayjs(bloodPressureMeasurement.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Registros de Peso e Altura"
				timeLineContents={(
					citizenWithAttendances.weightAndHeightMetricsRegisters ?? []
				).map<TimeLineContent>((metricsAttendance) => {
					return {
						content: (
							<IndicatorEsfC4CitizenAttendancesHistoryItem
								attendance={metricsAttendance}
							/>
						),
						eventDate: metricsAttendance.date
							? dayjs(metricsAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Avaliação dos pés"
				timeLineContents={(
					citizenWithAttendances.footAssessmentAttendanceProceduresReqEval ?? []
				).map<TimeLineContent>((attendanceProcedureReqEval) => {
					return {
						content: (
							<IndicatorEsfC4CitizenProcedureReqEvalsHistoryItem
								attendanceProcedureReqEval={attendanceProcedureReqEval}
							/>
						),
						eventDate: attendanceProcedureReqEval.date
							? dayjs(attendanceProcedureReqEval.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Hemoglobina glicada"
				timeLineContents={(
					citizenWithAttendances.glycatedHemoglobinAttendanceProceduresReqEval ?? []
				).map<TimeLineContent>((attendanceProcedureReqEval) => {
					return {
						content: (
							<IndicatorEsfC4CitizenProcedureReqEvalsHistoryItem
								attendanceProcedureReqEval={attendanceProcedureReqEval}
							/>
						),
						eventDate: attendanceProcedureReqEval.date
							? dayjs(attendanceProcedureReqEval.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
